import { initializeIcons } from "@fluentui/font-icons-mdl2";
import "core-js";
import "react-app-polyfill/stable.js";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App.js";
import GlobalCoachMark from "./components/custom/GlobalCoachMark.jsx";
import * as serviceWorker from "./serviceWorker.js";
import store from "./store.js";
import swConfig from "./swConfig.js";

initializeIcons("https://cdn.niroogenerator.ir/icons/font-icons-mdl2/fonts/");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
    <App />

    <ToastContainer
      stacked
      rtl
      theme='dark'
      pauseOnHover
      position='bottom-left'
      draggable
      transition={Zoom}
    />
    <GlobalCoachMark />
    {/* </React.StrictMode> */}
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register(swConfig);
// serviceWorker.unregister()
